import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      data-testid="theme-toggle-button"
      onClick={toggle}
      aria-label={isLight ? "Switch to dark mode" : "Switch to day mode"}
      className={`relative w-9 h-9 rounded-xl bg-[var(--surface-2)] border border-[var(--card3d-border)] hover:opacity-90 flex items-center justify-center transition-colors ${className}`}
    >
      <Sun
        size={16}
        className={`absolute transition-all duration-300 ${isLight ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-75"}`}
        style={{ color: "#F3BA2F" }}
      />
      <Moon
        size={15}
        className={`absolute transition-all duration-300 ${!isLight ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-75"}`}
        style={{ color: "#A78BFA" }}
      />
    </button>
  );
}

export default ThemeToggle;
